var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "book_info_title"
  }, [_vm.series ? _c('span', {
    staticClass: "book_info_series"
  }, [_vm._v(_vm._s(_vm.series))]) : _vm._e(), _c('strong', {
    staticClass: "title_inwrap"
  }, [_vm._v(_vm._s(_vm.title)), _vm.shareType && _vm.bookSeq ? _c('a', {
    staticClass: "book_info_link",
    attrs: {
      "href": "#none"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.shareHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "blind"
  }, [_vm._v("공유하기")])]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }